import { Spinner } from "@/components/ui";
import { Suspense } from "react";
import { socialNetworkNames, SocialNetworksId } from "@/interfaces";
import React from "react";
import { EmptyView } from "@/components/EmptyView";

const ResponsivePie = React.lazy(() => import("@nivo/pie").then(m => ({ default: m.ResponsivePie })));

interface Props {
  data: Array<{
    network: SocialNetworksId;
    count: number;
  }>;
}

export const ClicksByNetworkChart: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="py-8">
        <EmptyView text="No network-specific clicks recorded" />
      </div>
    );
  }

  const chartData = data.map(d => {
    const name = d.network === "SC" ? "Player Cards" : socialNetworkNames[d.network] || d.network;
    return {
      id: name,
      label: name,
      value: d.count,
    };
  });

  return (
    <div className="h-[300px] w-full">
      <Suspense
        fallback={
          <div className="h-full flex items-center justify-center">
            <Spinner />
          </div>
        }
      >
        <ResponsivePie
          data={chartData}
          margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
          innerRadius={0.5}
          padAngle={0.7}
          cornerRadius={3}
          activeOuterRadiusOffset={8}
          borderWidth={1}
          borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          arcLabelsSkipAngle={10}
          arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
          legends={[
            {
              anchor: "bottom",
              direction: "row",
              justify: false,
              translateX: 0,
              translateY: 56,
              itemsSpacing: 0,
              itemWidth: 100,
              itemHeight: 18,
              itemTextColor: "#999",
              itemDirection: "left-to-right",
              itemOpacity: 1,
              symbolSize: 18,
              symbolShape: "circle",
            },
          ]}
        />
      </Suspense>
    </div>
  );
};
